/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  QuotationRequest,
  QuotationRequestResponse,
  SearchQuotationRequestsRequest,
  SearchQuotationRequestsResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    QuotationRequestFromJSON,
    QuotationRequestToJSON,
    QuotationRequestResponseFromJSON,
    QuotationRequestResponseToJSON,
    SearchQuotationRequestsRequestFromJSON,
    SearchQuotationRequestsRequestToJSON,
    SearchQuotationRequestsResponseFromJSON,
    SearchQuotationRequestsResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnQuotationRequestByIdRequest {
    quotationRequestId: string;
    contentType: CreateChangeRequestOnQuotationRequestByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateQuotationRequestRequest {
    contentType: CreateQuotationRequestContentTypeEnum;
    xBOLMemberIdentifier: string;
    quotationRequest: QuotationRequest;
    id?: string;
    source?: boolean;
    accept?: CreateQuotationRequestAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateQuotationRequestEventRequest {
    quotationRequestId: string;
    contentType: CreateQuotationRequestEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateQuotationRequestEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteQuotationRequestACLAuthorizationByMemberIdRequest {
    quotationRequestId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteQuotationRequestByIdRequest {
    quotationRequestId: string;
    traceparent?: string;
}

export interface DeleteQuotationRequestEventByIdRequest {
    quotationRequestId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnQuotationRequestByIdRequest {
    quotationRequestId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationRequestACLAuthorizationByMemberIdRequest {
    quotationRequestId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetQuotationRequestACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationRequestACLByIdRequest {
    quotationRequestId: string;
    at?: string;
    revision?: string;
    accept?: GetQuotationRequestACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationRequestByIdRequest {
    quotationRequestId: string;
    at?: string;
    revision?: string;
    accept?: GetQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationRequestEventsRequest {
    quotationRequestId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetQuotationRequestEventsAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationRequestMetadataByIdRequest {
    quotationRequestId: string;
    accept?: GetQuotationRequestMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfQuotationRequestByIdRequest {
    quotationRequestId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchQuotationRequestByIdRequest {
    quotationRequestId: string;
    contentType: PatchQuotationRequestByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    quotationRequest: QuotationRequest;
    revision?: string;
    accept?: PatchQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchQuotationRequestGetRequest {
    id?: string;
    searchBody?: SearchQuotationRequestsRequest;
    accept?: SearchQuotationRequestGetAcceptEnum;
    traceparent?: string;
}

export interface SearchQuotationRequestsPostRequest {
    contentType: SearchQuotationRequestsPostContentTypeEnum;
    searchQuotationRequestsRequest: SearchQuotationRequestsRequest;
    limit?: number;
    offset?: number;
    accept?: SearchQuotationRequestsPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnQuotationRequestByIdRequest {
    quotationRequestId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnQuotationRequestByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateQuotationRequestByIdRequest {
    quotationRequestId: string;
    contentType: UpdateQuotationRequestByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    quotationRequest: QuotationRequest;
    revision?: string;
    accept?: UpdateQuotationRequestByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertQuotationRequestACLAuthorizationByIdRequest {
    quotationRequestId: string;
    contentType: UpsertQuotationRequestACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertQuotationRequestACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsQuotationRequestsApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific QuotationRequest resource, identified by its `QuotationRequestId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the QuotationRequest resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a QuotationRequest resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the QuotationRequest resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a QuotationRequest
     */
    async createChangeRequestOnQuotationRequestByIdRaw(requestParameters: CreateChangeRequestOnQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling createChangeRequestOnQuotationRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnQuotationRequestById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/change-requests`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific QuotationRequest resource, identified by its `QuotationRequestId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the QuotationRequest resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a QuotationRequest resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the QuotationRequest resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a QuotationRequest
     */
    async createChangeRequestOnQuotationRequestById(requestParameters: CreateChangeRequestOnQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnQuotationRequestByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new QuotationRequest.  When creating a QuotationRequest, the value of the header `X-BOL-Member-Identifier` defines the QuotationRequest\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a QuotationRequest, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the QuotationRequest and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the QuotationRequest, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the QuotationRequest.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a QuotationRequest
     */
    async createQuotationRequestRaw(requestParameters: CreateQuotationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationRequestResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createQuotationRequest().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createQuotationRequest().'
            );
        }

        if (requestParameters['quotationRequest'] == null) {
            throw new runtime.RequiredError(
                'quotationRequest',
                'Required parameter "quotationRequest" was null or undefined when calling createQuotationRequest().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationRequestToJSON(requestParameters['quotationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new QuotationRequest.  When creating a QuotationRequest, the value of the header `X-BOL-Member-Identifier` defines the QuotationRequest\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a QuotationRequest, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the QuotationRequest and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the QuotationRequest, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the QuotationRequest.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a QuotationRequest
     */
    async createQuotationRequest(requestParameters: CreateQuotationRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationRequestResponse | null | undefined > {
        const response = await this.createQuotationRequestRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a QuotationRequest by `quotationRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a QuotationRequest resource. 
     * Create an Event of a QuotationRequest
     */
    async createQuotationRequestEventRaw(requestParameters: CreateQuotationRequestEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling createQuotationRequestEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createQuotationRequestEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createQuotationRequestEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createQuotationRequestEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/events`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a QuotationRequest by `quotationRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a QuotationRequest resource. 
     * Create an Event of a QuotationRequest
     */
    async createQuotationRequestEvent(requestParameters: CreateQuotationRequestEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createQuotationRequestEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a QuotationRequest resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the QuotationRequest resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a QuotationRequest resource. 
     * Delete an authorization of an access control list of a QuotationRequest by memberId
     */
    async deleteQuotationRequestACLAuthorizationByMemberIdRaw(requestParameters: DeleteQuotationRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling deleteQuotationRequestACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteQuotationRequestACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteQuotationRequestACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a QuotationRequest resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the QuotationRequest resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a QuotationRequest resource. 
     * Delete an authorization of an access control list of a QuotationRequest by memberId
     */
    async deleteQuotationRequestACLAuthorizationByMemberId(requestParameters: DeleteQuotationRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotationRequestACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific QuotationRequest resource, identified by its `QuotationRequestId`.  - When a QuotationRequest is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a QuotationRequest resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a QuotationRequest resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a QuotationRequest resource. 
     * Delete a QuotationRequest by quotationRequestId
     */
    async deleteQuotationRequestByIdRaw(requestParameters: DeleteQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling deleteQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific QuotationRequest resource, identified by its `QuotationRequestId`.  - When a QuotationRequest is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a QuotationRequest resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a QuotationRequest resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a QuotationRequest resource. 
     * Delete a QuotationRequest by quotationRequestId
     */
    async deleteQuotationRequestById(requestParameters: DeleteQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotationRequestByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a QuotationRequest resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a QuotationRequest resource. 
     * Delete an event of a QuotationRequest by id
     */
    async deleteQuotationRequestEventByIdRaw(requestParameters: DeleteQuotationRequestEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling deleteQuotationRequestEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteQuotationRequestEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteQuotationRequestEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a QuotationRequest resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a QuotationRequest resource. 
     * Delete an event of a QuotationRequest by id
     */
    async deleteQuotationRequestEventById(requestParameters: DeleteQuotationRequestEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotationRequestEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given QuotationRequest, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the QuotationRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a QuotationRequest by changeRequestId
     */
    async getChangeRequestOnQuotationRequestByIdRaw(requestParameters: GetChangeRequestOnQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling getChangeRequestOnQuotationRequestById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given QuotationRequest, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the QuotationRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a QuotationRequest by changeRequestId
     */
    async getChangeRequestOnQuotationRequestById(requestParameters: GetChangeRequestOnQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnQuotationRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a QuotationRequest resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a QuotationRequest resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a QuotationRequest by memberId
     */
    async getQuotationRequestACLAuthorizationByMemberIdRaw(requestParameters: GetQuotationRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling getQuotationRequestACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getQuotationRequestACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a QuotationRequest resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a QuotationRequest resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a QuotationRequest by memberId
     */
    async getQuotationRequestACLAuthorizationByMemberId(requestParameters: GetQuotationRequestACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getQuotationRequestACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific QuotationRequest resource, identified by its `QuotationRequestId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the QuotationRequest and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a QuotationRequest resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a QuotationRequest for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getQuotationRequestACLByIdRaw(requestParameters: GetQuotationRequestACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling getQuotationRequestACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/acl`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific QuotationRequest resource, identified by its `QuotationRequestId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the QuotationRequest and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a QuotationRequest resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a QuotationRequest for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getQuotationRequestACLById(requestParameters: GetQuotationRequestACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getQuotationRequestACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific QuotationRequest by its `QuotationRequestId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this QuotationRequest resource. 
     * Get a QuotationRequest by quotationRequestId
     */
    async getQuotationRequestByIdRaw(requestParameters: GetQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationRequestResponse>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling getQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific QuotationRequest by its `QuotationRequestId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this QuotationRequest resource. 
     * Get a QuotationRequest by quotationRequestId
     */
    async getQuotationRequestById(requestParameters: GetQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationRequestResponse> {
        const response = await this.getQuotationRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a QuotationRequest by `quotationRequestId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a QuotationRequest resource. 
     * List Events of a QuotationRequest
     */
    async getQuotationRequestEventsRaw(requestParameters: GetQuotationRequestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling getQuotationRequestEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/events`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a QuotationRequest by `quotationRequestId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a QuotationRequest resource. 
     * List Events of a QuotationRequest
     */
    async getQuotationRequestEvents(requestParameters: GetQuotationRequestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getQuotationRequestEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific QuotationRequest by its `QuotationRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a QuotationRequest metadata by quotationRequestId
     */
    async getQuotationRequestMetadataByIdRaw(requestParameters: GetQuotationRequestMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling getQuotationRequestMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/metadata`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific QuotationRequest by its `QuotationRequestId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a QuotationRequest metadata by quotationRequestId
     */
    async getQuotationRequestMetadataById(requestParameters: GetQuotationRequestMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getQuotationRequestMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified QuotationRequest, identified by its `QuotationRequestId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given QuotationRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a QuotationRequest resource. 
     * Get a list of ChangeRequest for QuotationRequest
     */
    async listChangeRequestsOfQuotationRequestByIdRaw(requestParameters: ListChangeRequestsOfQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling listChangeRequestsOfQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/change-requests`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified QuotationRequest, identified by its `QuotationRequestId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given QuotationRequest resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a QuotationRequest resource. 
     * Get a list of ChangeRequest for QuotationRequest
     */
    async listChangeRequestsOfQuotationRequestById(requestParameters: ListChangeRequestsOfQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfQuotationRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing QuotationRequest identified by its `QuotationRequestId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a QuotationRequest resource. 
     * Partially update a QuotationRequest by applying a JSON Merge Patch change request
     */
    async patchQuotationRequestByIdRaw(requestParameters: PatchQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationRequestResponse>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling patchQuotationRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchQuotationRequestById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchQuotationRequestById().'
            );
        }

        if (requestParameters['quotationRequest'] == null) {
            throw new runtime.RequiredError(
                'quotationRequest',
                'Required parameter "quotationRequest" was null or undefined when calling patchQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationRequestToJSON(requestParameters['quotationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing QuotationRequest identified by its `QuotationRequestId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a QuotationRequest resource. 
     * Partially update a QuotationRequest by applying a JSON Merge Patch change request
     */
    async patchQuotationRequestById(requestParameters: PatchQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationRequestResponse> {
        const response = await this.patchQuotationRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of QuotationRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on QuotationRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of QuotationRequest resources. 
     * Search for QuotationRequests
     */
    async searchQuotationRequestGetRaw(requestParameters: SearchQuotationRequestGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchQuotationRequestsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchQuotationRequestsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of QuotationRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on QuotationRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of QuotationRequest resources. 
     * Search for QuotationRequests
     */
    async searchQuotationRequestGet(requestParameters: SearchQuotationRequestGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchQuotationRequestsResponse> {
        const response = await this.searchQuotationRequestGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of QuotationRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on QuotationRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of QuotationRequest resources. 
     * Search for QuotationRequests
     */
    async searchQuotationRequestsPostRaw(requestParameters: SearchQuotationRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchQuotationRequestsResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchQuotationRequestsPost().'
            );
        }

        if (requestParameters['searchQuotationRequestsRequest'] == null) {
            throw new runtime.RequiredError(
                'searchQuotationRequestsRequest',
                'Required parameter "searchQuotationRequestsRequest" was null or undefined when calling searchQuotationRequestsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQuotationRequestsRequestToJSON(requestParameters['searchQuotationRequestsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchQuotationRequestsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of QuotationRequest resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on QuotationRequests.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of QuotationRequest resources. 
     * Search for QuotationRequests
     */
    async searchQuotationRequestsPost(requestParameters: SearchQuotationRequestsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchQuotationRequestsResponse> {
        const response = await this.searchQuotationRequestsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given QuotationRequest, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a QuotationRequest resource. 
     * Accept or reject a ChangeRequest on a  QuotationRequest using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnQuotationRequestByIdRaw(requestParameters: UpdateChangeRequestOnQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling updateChangeRequestOnQuotationRequestById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnQuotationRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnQuotationRequestById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given QuotationRequest, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a QuotationRequest resource. 
     * Accept or reject a ChangeRequest on a  QuotationRequest using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnQuotationRequestById(requestParameters: UpdateChangeRequestOnQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnQuotationRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing QuotationRequest identified by its `QuotationRequestId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a QuotationRequest resource. 
     * Update an existing QuotationRequest by creating and applying a change request
     */
    async updateQuotationRequestByIdRaw(requestParameters: UpdateQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationRequestResponse>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling updateQuotationRequestById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateQuotationRequestById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateQuotationRequestById().'
            );
        }

        if (requestParameters['quotationRequest'] == null) {
            throw new runtime.RequiredError(
                'quotationRequest',
                'Required parameter "quotationRequest" was null or undefined when calling updateQuotationRequestById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationRequestToJSON(requestParameters['quotationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationRequestResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing QuotationRequest identified by its `QuotationRequestId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a QuotationRequest resource. 
     * Update an existing QuotationRequest by creating and applying a change request
     */
    async updateQuotationRequestById(requestParameters: UpdateQuotationRequestByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationRequestResponse> {
        const response = await this.updateQuotationRequestByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific QuotationRequest resource, identified by its `QuotationRequestId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a QuotationRequest resource. 
     * Upsert (create or update) an authorization of an access control list of a QuotationRequest.
     */
    async upsertQuotationRequestACLAuthorizationByIdRaw(requestParameters: UpsertQuotationRequestACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['quotationRequestId'] == null) {
            throw new runtime.RequiredError(
                'quotationRequestId',
                'Required parameter "quotationRequestId" was null or undefined when calling upsertQuotationRequestACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertQuotationRequestACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertQuotationRequestACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotation-requests/{quotationRequestId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"quotationRequestId"}}`, encodeURIComponent(String(requestParameters['quotationRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific QuotationRequest resource, identified by its `QuotationRequestId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a QuotationRequest resource. 
     * Upsert (create or update) an authorization of an access control list of a QuotationRequest.
     */
    async upsertQuotationRequestACLAuthorizationById(requestParameters: UpsertQuotationRequestACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertQuotationRequestACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnQuotationRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnQuotationRequestByIdContentTypeEnum = typeof CreateChangeRequestOnQuotationRequestByIdContentTypeEnum[keyof typeof CreateChangeRequestOnQuotationRequestByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnQuotationRequestByIdAcceptEnum = typeof CreateChangeRequestOnQuotationRequestByIdAcceptEnum[keyof typeof CreateChangeRequestOnQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const CreateQuotationRequestContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationRequestContentTypeEnum = typeof CreateQuotationRequestContentTypeEnum[keyof typeof CreateQuotationRequestContentTypeEnum];
/**
 * @export
 */
export const CreateQuotationRequestAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationRequestAcceptEnum = typeof CreateQuotationRequestAcceptEnum[keyof typeof CreateQuotationRequestAcceptEnum];
/**
 * @export
 */
export const CreateQuotationRequestEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationRequestEventContentTypeEnum = typeof CreateQuotationRequestEventContentTypeEnum[keyof typeof CreateQuotationRequestEventContentTypeEnum];
/**
 * @export
 */
export const CreateQuotationRequestEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationRequestEventAcceptEnum = typeof CreateQuotationRequestEventAcceptEnum[keyof typeof CreateQuotationRequestEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnQuotationRequestByIdAcceptEnum = typeof GetChangeRequestOnQuotationRequestByIdAcceptEnum[keyof typeof GetChangeRequestOnQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationRequestACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationRequestACLAuthorizationByMemberIdAcceptEnum = typeof GetQuotationRequestACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetQuotationRequestACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationRequestACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationRequestACLByIdAcceptEnum = typeof GetQuotationRequestACLByIdAcceptEnum[keyof typeof GetQuotationRequestACLByIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationRequestByIdAcceptEnum = typeof GetQuotationRequestByIdAcceptEnum[keyof typeof GetQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationRequestEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationRequestEventsAcceptEnum = typeof GetQuotationRequestEventsAcceptEnum[keyof typeof GetQuotationRequestEventsAcceptEnum];
/**
 * @export
 */
export const GetQuotationRequestMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationRequestMetadataByIdAcceptEnum = typeof GetQuotationRequestMetadataByIdAcceptEnum[keyof typeof GetQuotationRequestMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfQuotationRequestByIdAcceptEnum = typeof ListChangeRequestsOfQuotationRequestByIdAcceptEnum[keyof typeof ListChangeRequestsOfQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const PatchQuotationRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchQuotationRequestByIdContentTypeEnum = typeof PatchQuotationRequestByIdContentTypeEnum[keyof typeof PatchQuotationRequestByIdContentTypeEnum];
/**
 * @export
 */
export const PatchQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchQuotationRequestByIdAcceptEnum = typeof PatchQuotationRequestByIdAcceptEnum[keyof typeof PatchQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const SearchQuotationRequestGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchQuotationRequestGetAcceptEnum = typeof SearchQuotationRequestGetAcceptEnum[keyof typeof SearchQuotationRequestGetAcceptEnum];
/**
 * @export
 */
export const SearchQuotationRequestsPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchQuotationRequestsPostContentTypeEnum = typeof SearchQuotationRequestsPostContentTypeEnum[keyof typeof SearchQuotationRequestsPostContentTypeEnum];
/**
 * @export
 */
export const SearchQuotationRequestsPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchQuotationRequestsPostAcceptEnum = typeof SearchQuotationRequestsPostAcceptEnum[keyof typeof SearchQuotationRequestsPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnQuotationRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnQuotationRequestByIdContentTypeEnum = typeof UpdateChangeRequestOnQuotationRequestByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnQuotationRequestByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnQuotationRequestByIdAcceptEnum = typeof UpdateChangeRequestOnQuotationRequestByIdAcceptEnum[keyof typeof UpdateChangeRequestOnQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const UpdateQuotationRequestByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateQuotationRequestByIdContentTypeEnum = typeof UpdateQuotationRequestByIdContentTypeEnum[keyof typeof UpdateQuotationRequestByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateQuotationRequestByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateQuotationRequestByIdAcceptEnum = typeof UpdateQuotationRequestByIdAcceptEnum[keyof typeof UpdateQuotationRequestByIdAcceptEnum];
/**
 * @export
 */
export const UpsertQuotationRequestACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertQuotationRequestACLAuthorizationByIdContentTypeEnum = typeof UpsertQuotationRequestACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertQuotationRequestACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertQuotationRequestACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertQuotationRequestACLAuthorizationByIdAcceptEnum = typeof UpsertQuotationRequestACLAuthorizationByIdAcceptEnum[keyof typeof UpsertQuotationRequestACLAuthorizationByIdAcceptEnum];
